import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Referral, ReferralData } from 'src/shared/schemas/referrals'

/**
 * Creates a new referral with the provided data
 * @param referralData The referral data. Can include consumerId to link the referral to a consumer
 */
const createReferral = (referralData: ReferralData) => {
  return postRequest<Referral>('/referrals/', referralData)
}

/**
 * Hook for creating a new referral
 * @returns Mutation function that takes referral data including an optional consumerId
 */
export const useCreateReferral = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (referralData: ReferralData) => createReferral(referralData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.referrals.list._def })
    },
  })
}
